import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Users, Sparkles } from 'lucide-react';
import { CITYTOON_LOGO_URL } from '../components/Logo';
import { useTexts } from '../context/TextsContext';

const About = () => {
  const { t } = useTexts();
  return (
    <div className="max-w-4xl mx-auto px-4 py-12" data-testid="about-page">
      <div className="text-center mb-10">
        <img src={CITYTOON_LOGO_URL} alt="Citytoon" className="w-24 h-24 object-contain mx-auto mb-4" />
        <h1 className="font-display font-700 text-4xl mb-2">{t('about_title', 'À propos de Citytoon')}</h1>
        <p className="text-primary font-800">{t('about_subtitle', 'Le webtoon du réel')}</p>
      </div>
      <div className="prose max-w-none text-foreground/80 space-y-4 text-lg">
        <p>{t('about_p1', 'Citytoon est une plateforme dédiée au webtoon didactique : des bandes dessinées verticales qui racontent le patrimoine, l’histoire et les territoires, à lire d’un simple scroll.')}</p>
        <p>{t('about_p2', 'Tous les contenus sont publiés à la source sur citytoon.org et synchronisés ici en lecture seule. Les images restent hébergées par Citytoon.')}</p>
      </div>
      <div className="grid sm:grid-cols-3 gap-4 mt-10">
        <Link to="/catalogue" className="card-hover bg-card border border-border rounded-2xl p-6 text-center"><BookOpen className="w-8 h-8 text-primary mx-auto mb-2" /><p className="font-800">Explorer les webtoons</p></Link>
        <Link to="/auteurs" className="card-hover bg-card border border-border rounded-2xl p-6 text-center"><Users className="w-8 h-8 text-primary mx-auto mb-2" /><p className="font-800">Auteurs et autrices</p></Link>
        <a href="https://citytoon.org" target="_blank" rel="noreferrer" className="card-hover bg-card border border-border rounded-2xl p-6 text-center"><Sparkles className="w-8 h-8 text-primary mx-auto mb-2" /><p className="font-800">citytoon.org</p></a>
      </div>
    </div>
  );
};

export default About;
